import { useMemo } from "react";
import { AssetWithPosition } from "../data/types/portfolio-statement/portfolio-statement";
import {
  orderAssetsByIssuerValue,
  getAssetOrderNumber,
  aggregateAssetsByIssuer,
} from "../utils/assetOrdering";

interface UseAssetOrderingReturn {
  orderedAssets: AssetWithPosition[];
  getAssetOrder: (assetId: string) => number;
  issuerTotals: Map<string, number>;
}

export const useAssetOrdering = (
  assets: AssetWithPosition[],
): UseAssetOrderingReturn => {
  const orderedAssets = useMemo(
    () => orderAssetsByIssuerValue(assets),
    [assets],
  );

  const issuerTotals = useMemo(() => {
    const aggregations = aggregateAssetsByIssuer(assets);
    const totals = new Map<string, number>();
    for (const agg of aggregations) {
      totals.set(agg.issuerId, agg.totalValue);
    }
    return totals;
  }, [assets]);

  const getAssetOrder = useMemo(
    () => (assetId: string) => getAssetOrderNumber(assetId, orderedAssets),
    [orderedAssets],
  );

  return {
    orderedAssets,
    getAssetOrder,
    issuerTotals,
  };
};
